const ChatInputInnerBlock = ({ children }) => {
    return(
        <div className="col-12 input-area-inner w-75">
            {children}
        </div>
    );
}

export default ChatInputInnerBlock;